"use strict";

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@emotion/core");

var react_1 = require("react");

var flex_1 = require("./flex");

var parseCssSizeString = function parseCssSizeString(inp) {
  var n = parseFloat(inp);
  var p = inp.match(/(%|rem|em)/);
  return isNaN(n) || n === 0 ? '' : p && p.length > 0 ? "" + n + p[0] : n + "px";
};

var alignOptions = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end'
};
var spaceOptions = {
  between: 'space-between',
  around: 'space-around',
  evenly: 'space-evenly'
};
exports.Stack = react_1.forwardRef(function (_a, ref) {
  var direction = _a.direction,
      space = _a.space,
      alignMain = _a.alignMain,
      alignCross = _a.alignCross,
      stretch = _a.stretch,
      children = _a.children,
      other = __rest(_a, ["direction", "space", "alignMain", "alignCross", "stretch", "children"]);

  var s = !!space && typeof space !== 'number' && spaceOptions[space];
  var customS = s || !space ? undefined : typeof space === 'number' ? isNaN(space) ? undefined : space + "px" : parseCssSizeString(space);
  return core_1.jsx(flex_1.Flex, __assign({
    ref: ref,
    css: {
      flexDirection: direction === 'column' ? direction : 'row',
      justifyContent: s ? s : alignMain && alignOptions[alignMain] || 'flex-start',
      alignItems: stretch && 'stretch' || alignCross && alignOptions[alignCross] || 'flex-start'
    }
  }, other), customS ? react_1.Children.toArray(children).reduce(function (res, c, i) {
    if (i < 1) {
      return [c];
    } else {
      return __spreadArrays(res, [core_1.jsx("div", {
        key: "space-" + i,
        css: {
          flex: "0 0 " + customS,
          blockSize: customS
        }
      }), c]);
    }
  }, []) : children);
});